import React, { useEffect, useState, useMemo } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
// Хуки для роутинга (v5)
import { useHistory, useParams } from 'react-router-dom';
import { termsState, isLoadingState } from '../../../atoms/dataAtoms';
import { physicsApi } from '../../../api';

import TermsRead from './TermsRead'; // Создадим его на следующем шаге
import FormulaNothingFound from '../formuls/FormulaNothingFound'; // Переиспользуем
import FormulaLoading from '../formuls/FormulaLoading';           // Переиспользуем

import SEO from '../../../seo';

const TermsFragment = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language ? i18n.language.substring(0, 2) : 'en';

    const history = useHistory();
    // Для терминов нам тоже понадобятся параметры URL (цвет и ID)
    const { colorId, termId } = useParams();

    const [terms, setTerms] = useRecoilState(termsState);
    const [loading, setLoading] = useRecoilState(isLoadingState);

    const [searchTerm, setSearchTerm] = useState('');
    const [placeholderText, setPlaceholderText] = useState(t('translate.search_placeholder'));

    useEffect(() => {
        const fetchData = async () => {
            if (terms.length > 0) return;
            setLoading(true);
            try {
                const response = await physicsApi.getTermsList(currentLang);
                setTerms(response.data);
            } catch (error) {
                console.error("Ошибка загрузки:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [setTerms, terms.length, setLoading]);

    useEffect(() => {
        if (terms.length > 0) {
            const randomIndex = Math.floor(Math.random() * terms.length);
            const randomTerm = terms[randomIndex];
            if (randomTerm && randomTerm.content.termName) {
                setPlaceholderText(`${randomTerm.content.termName}...`);
            }
        }
    }, [terms]);

    // Фильтрация + Сортировка по алфавиту
    const filteredTerms = useMemo(() => {
        const filtered = terms.filter((item) => {
            const name = item.content.termName.toLowerCase();
            const desc = item.content.termDescription.toLowerCase();
            const query = searchTerm.toLowerCase();

            return name.includes(query) || desc.includes(query);
        });

        return filtered.sort((a, b) => {
            return a.content.termName.localeCompare(b.content.termName, 'ru');
        });

    }, [terms, searchTerm]);

    // Ищем термин для модалки, если в URL есть termId
    const activeTerm = useMemo(() => {
        if (!termId || terms.length === 0) return null;
        return terms.find(t => String(t._id) === String(termId));
    }, [terms, termId]);

    const handleClearSearch = () => {
        setSearchTerm('');
    };

    // Обработчики открытия и закрытия модалки
    const handleTermClick = (item) => {
        let safeColorId = 0;
        if (item.color !== undefined && item.color >= 0 && item.color <= 9) {
            safeColorId = item.color;
        }
        // Переход по ссылке, чтобы открыть модалку
        history.push(`/terms/${safeColorId}/${item._id}`);
    };

    const handleCloseModal = () => {
        history.push('/terms');
    };

    {/*---LOADER---*/}
    if (loading) {
        return <FormulaLoading />;
    }
    {/*---LOADER---*/}

    return (
        // Используем те же классы, что и в формулах для идеального совпадения
        <div className="terms-page">
            <SEO>
                {/* Словарь терминов – Физика */}
                <title>{`${t('translate.app_name2')}: ${t('translate.terms_name')}`}</title>
            </SEO>

            {/* --- TOOLBAR --- */}
            <div className="toolbar">
                <div className="toolbar__header">
                    <h1 className="toolbar__title">{t('translate.app_name2')}</h1>
                    <span className="toolbar__subtitle_terms">{t('translate.terms_name') || 'Словарь терминов'}</span>
                </div>

                <div className="toolbar__search-wrapper">
                    <input
                        type="text"
                        className="toolbar__input"
                        placeholder={placeholderText}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {searchTerm && (
                        <button
                            className='toolbar__reset-button'
                            onClick={handleClearSearch}
                            title={t('translate.search_clear') || "Очистить"}
                        />
                    )}
                </div>
            </div>

            {/* --- СПИСОК ТЕРМИНОВ --- */}
            {filteredTerms.length > 0 ? (
                // Используем класс formulas-grid, чтобы получить те же 3 колонки
                <div className="terms-grid">
                    {filteredTerms.map((item) => {
                        const firstLetter = item.content.termName
                            ? item.content.termName.charAt(0).toUpperCase()
                            : '?';

                        const colorId = item.color;
                        const colorClassSuffix = colorId !== undefined ? colorId : 'default';

                        return (
                            <div
                                key={item._id}
                                className={`term-card term-card--${colorClassSuffix}`}
                                onClick={() => handleTermClick(item)}
                            >
                                <div className="term-card__icon">
                                    {firstLetter}
                                </div>

                                <div className="term-card__content">
                                    <h3 className="term-card__title">{item.content.termName}</h3>
                                    <p className="term-card__desc">{item.content.termDescription}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                // --- НИЧЕГО НЕ НАЙДЕНО ---
                <FormulaNothingFound searchTerm={searchTerm} />
            )}

            {/* --- READ-TERMS (МОДАЛКА) --- */}
            {activeTerm && (
                <TermsRead
                    term={activeTerm}
                    colorId={colorId}
                    onClose={handleCloseModal}
                />
            )}




            {/* ============================== КОПИРАЙТ ============================== */}
            <div className="settings-footer" style={{marginTop: '40px'}}>
                <p>© <a href='https://chernykh.tech/' target='_blank' rel='noreferrer'>chernykh.tech</a> / All rights reserved, {new Date().getFullYear()}</p>
            </div>

        </div>
    );
};

export default TermsFragment;